module.exports = __webpack_public_path__ + "img/dianshang.17dcef2.webp";